import { useEffect } from 'react';
import { useSubscription } from '@apollo/client';
import { useInstallationContext } from '../../../../../../context/installation';
import {
  OnRequestAckReceivedSubscription,
  OnRequestAckReceivedSubscriptionVariables,
  OnBinarySensorValueChangeSubscription,
  OnBinarySensorValueChangeSubscriptionVariables,
  RequestAckPayload,
  BinarySensorValueChangePayload,
} from '../../../../../../data-access/gql-types/graphql';
import {
  ON_REQUEST_ACK_RECEIVED,
  ON_BINARY_SENSOR_VALUE_CHANGE,
} from '../../../../../../data-access/subscriptions/lavva-devices';
import { useUpdateCommonLavvaState } from '../common-lavva-state';
import { ChannelSubscriptionParams } from '../types';
import { useLavvaDeviceBinarySensorUpdate } from './update';

export const useBinarySensorSubscriptions = ({ channelId }: ChannelSubscriptionParams) => {
  const { updateLavvaBinarySensorState } = useLavvaDeviceBinarySensorUpdate();
  const { onRequestAckReceived } = useUpdateCommonLavvaState();
  const { skipLavvaFetch } = useInstallationContext();
  const { data: binarySensorChange } = useSubscription<
    OnBinarySensorValueChangeSubscription,
    OnBinarySensorValueChangeSubscriptionVariables
  >(ON_BINARY_SENSOR_VALUE_CHANGE, {
    variables: { channelId },
    skip: skipLavvaFetch,
  });
  const { data: ackReceived } = useSubscription<
    OnRequestAckReceivedSubscription,
    OnRequestAckReceivedSubscriptionVariables
  >(ON_REQUEST_ACK_RECEIVED, {
    variables: { channelOrDeviceId: channelId },
    skip: skipLavvaFetch,
  });

  useEffect(() => {
    if (binarySensorChange) {
      updateLavvaBinarySensorState(binarySensorChange.onBinarySensorValueChange as BinarySensorValueChangePayload);
    }
  }, [binarySensorChange]);

  useEffect(() => {
    if (ackReceived) onRequestAckReceived(ackReceived.onRequestAckReceived as RequestAckPayload);
  }, [ackReceived]);
};
